import AdvancedFilter from "./AdvancedFilter"

export default  AdvancedFilter;



// WEBPACK FOOTER //
// ./src/components/App/GroupsManagerDashboard/SubHeader/AdvancedFilter/index.js